import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import InfoItem from "components/common/detailsPage/InfoItem";
import NoPermission from "components/common/NoPermission";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { StatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getBannerDetails } from "store/slices/bannersSlice";
import { formatUTCDate } from "utils/utils";

const BannerDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");

  const { canAction } = usePermission();
  const { canView } = canAction("banners");
  const { loading, itemDetails } = useSelector((state) => state.Banners);

  const { imageUrl, title, description, status, createdAt } = itemDetails || {};

  useEffect(() => {
    if (id && canView) {
      dispatch(getBannerDetails(id));
    }
  }, [id, canView]);

  const infoFields = [
    {
      label: t("Banner Image"),
      value: (
        <div>
          <img src={imageUrl} alt="" className="img-fluid" />
        </div>
      ),
      col: { lg: 6 },
    },
    {
      label: t("Phone Number"),
      value: "phone",
      col: { lg: 2, md: 3 },
    },
  ];
  const shimmerLayout = [
    {
      col: 6,
      type: "shimmer_image",
      blocks: [{ rows: 1, cols: 1 }],
    },
    {
      col: 6,
      blocks: [
        { rows: 1, cols: 3 },
        { rows: 1, cols: 1 },
      ],
    },
  ];

  if (!canView) return <NoPermission />;

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Banner Details")} />
        <div className="common_card">
          <DetailsShimmer layout={shimmerLayout} />
        </div>
      </div>
    );
  }

  return (
    <div className="page-content common_details_page">
      <DetailsTitle title={t("Banner Details")} />
      <div className="common_card">
        <Row>
          <Col lg={5}>
            <img src={imageUrl} alt="" className="img-fluid rounded-3" />
          </Col>
          <Col lg={7}>
            <Row id="banner_details" className="details_page_item_row">
              <InfoItem
                label={t("Title")}
                value={title?.en}
                col={{ lg: 4, md: 6 }}
              />
              <InfoItem
                label={t("Created Date")}
                value={formatUTCDate(createdAt)}
                col={{ lg: 4, md: 6 }}
              />
              <InfoItem
                label={t("Status")}
                value={<StatusBadge status={status} t={t} />}
                col={ {lg: 4 ,md:6}}
              />
              <div className="mt-4 d-sm-none"></div>
              <InfoItem
                label={t("Description")}
                value={description?.en}
                col={{lg: 4 ,md:6}}
              />
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BannerDetails;
